namespace GeniuzPOS.CustomReport {
    export interface ReportCusSaleReportRow {
        Id?: string;
        BrandName?: string;
        SupplierId?: string;
        SupplierName?: string;
        Category1?: string;
        Category2?: string;
        Category3?: string;
        SkuCode?: string;
        PluCode?: string;
        SkuDesc?: string;
        QtySold?: number;
        ExPrice?: number;
        DisCount?: number;
        NetSale?: number;
        AvgPrice?: number;
        NetSalesExVat?: number;
        CostOfGoods?: number;
        VatAmt?: number;
        GrossMargin?: number;
        GrossPc?: number;
        DiscountCom?: number;
        DiscountSup?: number;
        DiscountMb?: number;
        DiscountBill?: number;
        DiscountSum?: number;
        NetMargin?: number;
        NetGp?: number;
        NetGpVender?: number;
        OnHandQty?: number;
    }

    export namespace ReportCusSaleReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BrandName';
        export const localTextPrefix = 'CustomReport.ReportCusSaleReport';
        export const deletePermission = '6CustomReport:Sale Report:View';
        export const insertPermission = '6CustomReport:Sale Report:View';
        export const readPermission = '6CustomReport:Sale Report:View';
        export const updatePermission = '6CustomReport:Sale Report:View';

        export declare const enum Fields {
            Id = "Id",
            BrandName = "BrandName",
            SupplierId = "SupplierId",
            SupplierName = "SupplierName",
            Category1 = "Category1",
            Category2 = "Category2",
            Category3 = "Category3",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            SkuDesc = "SkuDesc",
            QtySold = "QtySold",
            ExPrice = "ExPrice",
            DisCount = "DisCount",
            NetSale = "NetSale",
            AvgPrice = "AvgPrice",
            NetSalesExVat = "NetSalesExVat",
            CostOfGoods = "CostOfGoods",
            VatAmt = "VatAmt",
            GrossMargin = "GrossMargin",
            GrossPc = "GrossPc",
            DiscountCom = "DiscountCom",
            DiscountSup = "DiscountSup",
            DiscountMb = "DiscountMb",
            DiscountBill = "DiscountBill",
            DiscountSum = "DiscountSum",
            NetMargin = "NetMargin",
            NetGp = "NetGp",
            NetGpVender = "NetGpVender",
            OnHandQty = "OnHandQty"
        }
    }
}
